import { render, staticRenderFns } from "./IllustrationColorsSection.vue?vue&type=template&id=12e6b890&scoped=true"
import script from "./IllustrationColorsSection.vue?vue&type=script&lang=ts"
export * from "./IllustrationColorsSection.vue?vue&type=script&lang=ts"
import style0 from "./IllustrationColorsSection.vue?vue&type=style&index=0&id=12e6b890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e6b890",
  null
  
)

export default component.exports